import styled from 'styled-components';

interface ItemProps {
  readonly padding?: string;
}

export const WhiteSection = styled.section<ItemProps>`
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.02);
  background-color: var(--BackgroundColor);
  border: 1px solid var(--LightGray);
  padding: ${props => props.padding};
  border-radius: 8px;
  overflow-x: auto;
`;
